import React from 'react'
import Modal from '../Modal'

const FrequentlyAskedQuestionsModal = ({ faq, open, handleClose }) => {
  return (
    <Modal noPadding open={open} noButtons onCancel={handleClose}>
      <div className="w-full">
        <div className="font-bold text-center mb-6 mx-8 md:mx-0">Frequently Asked Questions</div>
        <div className="grid mb-4">
          {faq.map((faqObject, index) => (
            <div
              key={index}
              className="overflow-auto break-words even:bg-white odd:bg-gray-50 py-5 px-9"
            >
              <p className="paragraph-with-green-line relative font-bold">{faqObject.question}</p>
              <p className="text-gray-500 mt-2">{faqObject.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default FrequentlyAskedQuestionsModal
